import { useMediaQuery } from "@material-ui/core";

export function IsSmall() {
  return (
    useMediaQuery("(max-width:1200px)") && /mobile/i.test(navigator.userAgent)
  );
}

export function IsMobile900() {
  return (
    useMediaQuery("(max-width:900px)") && /mobile/i.test(navigator.userAgent)
  );
}

export function IsMobile() {
  return (
    useMediaQuery("(max-width:700px)") && /mobile/i.test(navigator.userAgent)
  );
}

export function IsMobile500() {
  return (
    useMediaQuery("(max-width:500px)") && /mobile/i.test(navigator.userAgent)
  );
}

export function IsMobile300() {
  return (
    useMediaQuery("(max-width:300px)") && /mobile/i.test(navigator.userAgent)
  );
}
